import actionsRequiredActions, { Actions as ActionsRequiredActions } from './chat/actionsRequiredReducer/actions';
import upcomingBookingsActions, { Actions as UpcomingBookingsActions } from './bookings/upcomingBookingsReducer/actions';
import chatContactsActions, { Actions as ChatContactsActions } from './chat/chatContactsReducer/actions';
import contactsActions, { Actions as ContactsActions } from './chat/contactsReducer/actions';
import messagesActions, { Actions as MessagesActions } from './chat/messagesReducer/actions';
import bookingsActions, { Actions as BookingsActions } from './bookings/bookingsReducer/actions';
import archivedBookingsActions, { Actions as ArchivedBookingsActions } from './bookings/archivedBookingsReducer/actions';
import ActionsRequiredActionTypes from './chat/actionsRequiredReducer/ActionTypes';
import UpcomingBookingsActionTypes from './bookings/upcomingBookingsReducer/ActionTypes'
import ChatContactsActionTypes from './chat/chatContactsReducer/ActionTypes'
import ContactsActionTypes from './chat/contactsReducer/ActionTypes'
import MessagesActionTypes from './chat/messagesReducer/ActionTypes'
import BookingActionsType from './bookings/bookingsReducer/ActionTypes';
import ArchivedBookingActionsType from './bookings/archivedBookingsReducer/ActionTypes';

export type CombinedActionTypes = ActionsRequiredActionTypes | UpcomingBookingsActionTypes | ChatContactsActionTypes | ContactsActionTypes | MessagesActionTypes | BookingActionsType | ArchivedBookingActionsType;

export interface CombinedActions {
  actionsRequired: ActionsRequiredActions;
  upcomingBookings: UpcomingBookingsActions;
  archivedBookings: ArchivedBookingsActions;
  chatContacts: ChatContactsActions;
  contacts: ContactsActions;
  messages: MessagesActions;
  bookings: BookingsActions;
}

const actionsFactory = (dispatch): CombinedActions => ({
  actionsRequired: actionsRequiredActions(dispatch),
  upcomingBookings: upcomingBookingsActions(dispatch),
  archivedBookings: archivedBookingsActions(dispatch),
  chatContacts: chatContactsActions(dispatch),
  contacts: contactsActions(dispatch),
  messages: messagesActions(dispatch),
  bookings: bookingsActions(dispatch),
});

export default actionsFactory;
